/* RESPONSIBLE TEAM: team-proactive-support */
import { readOnly } from '@ember/object/computed';
import BaseProductIndexRoute from 'embercom/routes/base/product-index-route';

export default BaseProductIndexRoute.extend({
  product: readOnly('app.messagesProduct'),
  defaultRoutePath: 'apps.app.outbound.all',
  salesUseCaseAppRoute: 'apps.app.outbound.all',
});
